import { render } from "./CRMDashboard.vue?vue&type=template&id=3d60057a&scoped=true&ts=true"
import script from "./CRMDashboard.vue?vue&type=script&lang=ts"
export * from "./CRMDashboard.vue?vue&type=script&lang=ts"

import "./CRMDashboard.vue?vue&type=style&index=0&id=3d60057a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d60057a"]])

export default __exports__